import { useMainLayout } from '../components/layouts/MainPageLayout/MainLayoutContext';
import { DisplayingRegionLevel } from '../types/DisplayingRegionLevel';

export const useSidebarTitle = (): string => {
  const { selectedRegionId, regionsMapping, displayMode, visibleRegionIds } = useMainLayout();

  if (!selectedRegionId && visibleRegionIds.length === 1) {
    const { regionId } = visibleRegionIds[0];
    return regionsMapping[regionId] || 'Region on map';
  }
  if (displayMode === DisplayingRegionLevel.COUNTRY) return 'All portfolio states';
  if (displayMode === DisplayingRegionLevel.STATE && !selectedRegionId) return 'Portfolio states on map';
  if (displayMode === DisplayingRegionLevel.METRO_AREA && !selectedRegionId) return 'Portfolio metro areas on map';
  if (displayMode === DisplayingRegionLevel.CITY && !selectedRegionId) return 'Portfolio cities on map';
  if (displayMode === DisplayingRegionLevel.ZIP && !selectedRegionId) return 'Portfolio zip codes on map';

  if (!selectedRegionId) return 'Regions on map';

  if (selectedRegionId) return regionsMapping[selectedRegionId] || 'Selected region';

  return 'Regions on map';
};
